import * as React from "react";
import { cn } from "@/lib/utils";
interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  variant?: "default" | "muted" | "card";
}
const Section = React.forwardRef<HTMLElement, SectionProps>(({
  className,
  variant = "default",
  ...props
}, ref) => {
  const variantClasses = {
    default: "",
    muted: "bg-card/30",
    card: "bg-card/50"
  };
  return <section ref={ref} className={cn("py-20 px-4", variantClasses[variant], className)} {...props} />;
});
Section.displayName = "Section";
interface SectionHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  subtitle?: React.ReactNode;
  centered?: boolean;
}
const SectionHeader = React.forwardRef<HTMLDivElement, SectionHeaderProps>(({
  className,
  title,
  subtitle,
  centered = true,
  ...props
}, ref) => <div ref={ref} className={cn("mb-16", centered && "text-center", className)} {...props}>
      <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6 text-foreground">
        {title}
      </h2>
      {subtitle && (
        <p className="text-base sm:text-lg md:text-xl text-muted-foreground leading-relaxed max-w-3xl mx-auto whitespace-pre-line">
          {subtitle}
        </p>
      )}
    </div>);
SectionHeader.displayName = "SectionHeader";
interface SectionContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  maxWidth?: "4xl" | "5xl" | "6xl" | "7xl";
}
const SectionContainer = React.forwardRef<HTMLDivElement, SectionContainerProps>(({
  className,
  maxWidth = "6xl",
  ...props
}, ref) => <div ref={ref} className={cn("container mx-auto", {
  "max-w-4xl": maxWidth === "4xl",
  "max-w-5xl": maxWidth === "5xl",
  "max-w-6xl": maxWidth === "6xl",
  "max-w-7xl": maxWidth === "7xl"
}, className)} {...props} />);
SectionContainer.displayName = "SectionContainer";
export { Section, SectionHeader, SectionContainer };